import * as React from 'react';
import Svg, {G, Path, Rect} from 'react-native-svg';
import {memo} from 'react';

interface IProps {
  width?: number;
  height?: number;
}

const Pay365MenuItemBoilerPlate = memo(
  ({width = 110, height = 110}: IProps) => (
    <Svg width={width} height={height} viewBox="0 0 110 110" fill="none">
      <Rect
        opacity="0.95"
        x="0.5"
        y="0.5"
        width="109"
        height="109"
        rx="7.5"
        fill="#066DFF"
        stroke="#CFCFCF"
      />
      <G clip-path="url(#clip0_25659_30638)">
        <Path
          d="M49.2936 57.4551C49.2936 59.8078 47.2715 61.4209 44.0639 61.4209C40.8562 61.4209 38.8145 59.7881 38.8145 56.8716H41.5946C41.6335 58.4076 42.7222 59.2243 44.1996 59.2243C45.4635 59.2243 46.4548 58.505 46.4548 57.2799C46.4548 56.2109 45.6578 55.53 44.083 55.53H42.7414V53.2944H43.9276C45.4247 53.2944 46.1828 52.5363 46.1828 51.4667C46.1828 50.3588 45.2495 49.7753 44.083 49.7753C42.7611 49.7753 41.8278 50.592 41.7889 51.8554H39.0476C39.0865 49.3084 41.1474 47.5781 44.1219 47.5781C47.1938 47.5781 49.021 49.0167 49.021 51.2527C49.021 52.9053 47.9908 53.8774 46.6492 54.2272C48.1074 54.5189 49.293 55.4714 49.293 57.4546L49.2936 57.4551Z"
          fill="white"
        />
        <Path
          d="M50.1939 54.6365C50.1939 50.0872 52.3714 47.5791 55.7931 47.5791C58.3401 47.5791 60.3424 49.0373 60.6533 51.5257H57.8928C57.64 50.437 56.7849 49.8343 55.5791 49.8343C53.8291 49.8343 52.8378 51.234 52.8378 53.7421V54.0727C52.8963 53.9753 52.9352 53.8976 53.0129 53.781C53.6353 52.8088 54.8209 52.187 56.2206 52.187C58.9619 52.187 60.8279 54.0535 60.8279 56.7943C60.8279 59.5745 58.7867 61.4214 55.7537 61.4214C53.8482 61.4214 52.3906 60.6435 51.4376 59.2827C50.6406 58.136 50.1934 56.5223 50.1934 54.636L50.1939 54.6365ZM55.7734 54.3645C54.3929 54.3645 53.4404 55.3366 53.4404 56.7948C53.4404 58.2531 54.354 59.2252 55.7345 59.2252C57.115 59.2252 58.0286 58.2339 58.0286 56.7948C58.0286 55.3558 57.1539 54.3645 55.7734 54.3645Z"
          fill="white"
        />
        <Path
          d="M72.1828 56.6975C72.1828 59.8274 69.8499 61.4219 67.0309 61.4219C63.8812 61.4219 61.9374 59.4196 61.8203 56.9312H64.6005C64.7368 58.1562 65.5918 59.1279 67.05 59.1279C68.2362 59.1279 69.3638 58.3112 69.3638 56.6975C69.3638 55.2589 68.4502 54.2479 67.0309 54.2479C66.2727 54.2479 65.2228 54.5397 64.7368 55.6673H62.0343L62.423 47.6963H71.3661V50.0489H64.97L64.8145 53.0234C65.4949 52.4011 66.3893 52.0321 67.5947 52.0321C70.336 52.0321 72.1828 53.9173 72.1828 56.6975Z"
          fill="white"
        />
        <Path
          d="M55.5001 87.2423C37.446 87.2423 22.7578 72.5541 22.7578 54.5001C22.7578 36.446 37.446 21.7578 55.5001 21.7578C73.5541 21.7578 88.2423 36.446 88.2423 54.5001H84.5156C84.5156 38.5006 71.4996 25.4846 55.5001 25.4846C39.5006 25.4846 26.4846 38.5006 26.4846 54.5001C26.4846 70.4996 39.5006 83.5156 55.5001 83.5156V87.2423Z"
          fill="white"
        />
        <Path
          d="M55.4997 79.7894C41.5557 79.7894 30.2109 68.4446 30.2109 54.5007H33.9377C33.9377 66.3901 43.6102 76.0626 55.4997 76.0626C67.3891 76.0626 77.0616 66.3901 77.0616 54.5007C77.0616 42.6112 67.3891 32.9387 55.4997 32.9387V29.2119C69.4436 29.2119 80.7884 40.5567 80.7884 54.5007C80.7884 68.4446 69.4436 79.7894 55.4997 79.7894Z"
          fill="white"
        />
      </G>
    </Svg>
  ),
);
export default Pay365MenuItemBoilerPlate;
